import { useNavigate } from 'react-router-dom';
import { Box, Button } from '@mui/joy';

export function FormButtons({ isSaving, order = 'ltr', saveLabel = 'Save', cancelLabel = 'Cancel', sx }) {
  const navigate = useNavigate();
  return (
    <Box sx={{ display: 'flex', gap: 1, width: { xs: '100%', md: 'auto' }, flexDirection: order === 'ltr' ? 'row' : 'row-reverse', ...sx }}>      
      <Button type="submit" loading={isSaving} sx={{ width: { xs: '100%', md: 'auto' } }}>{ saveLabel }</Button>      
      <Button variant="outlined" color="neutral" onClick={() => navigate(-1)} sx={{ width: { xs: '100%', md: 'auto' } }}>{ cancelLabel }</Button>
    </Box>
  );
}